<template>
  <CCard class="cursor p-0 mr-3">
    <CCardHeader class="p-0 position-relative">
      <image-view
        :src="
          blogDetails.cover_photo
            ? blogDetails.cover_photo
            : '/img/avatars/default-blog.png'
        "
        alt="user image"
      ></image-view>
      <div class="status-div">
        <p
          v-if="!!blogDetails.is_published && blogDetails.status === 'APPROVED'"
          class="published mb-0"
        >Published</p>
        <p
          v-if="!blogDetails.is_published && blogDetails.status === 'APPROVED'"
          class="unpublished mb-0"
        >Unpublished</p>
        <p
          v-if="
            (!blogDetails.is_published || !!blogDetails.is_published) &&
            blogDetails.status === 'DRAFT'
          "
          class="drafts mb-0"
        >Draft</p>
      </div>
    </CCardHeader>
    <CCardBody class="py-2">
      <h5 class="title text-capitalize">
        <b>{{ blogDetails.title }}</b>
      </h5>
      <div class="d-just-space mb-2">
        <p class="mb-0 text-capitalize">
          By DocSmart
          <br />
          <b>{{ getDate(blogDetails.blog_update) }}</b>
        </p>
        <div class="d-flex">
          <div class="blog-count mr-2 d-align">
            <image-view :src="'/img/avatars/visibility.png'" class="mr-1 eye-view"></image-view>
            <p class="mb-0">{{ blogDetails.views_count }}</p>
          </div>
          <div class="blog-count mr-2 d-align">
            <image-view :src="'/img/avatars/speech-bubble.png'" class="mr-1"></image-view>
            <p class="mb-0">{{ commentNumber }}</p>
          </div>
          <div class="blog-count d-align">
            <image-view :src="'/img/avatars/like.png'" class="mr-1"></image-view>
            <p class="mb-0">{{ blogDetails.likes.length }}</p>
          </div>
        </div>
      </div>
      <p v-html="blogDetails.short_description" class="text mb-2"></p>
      <div
        class="text-capitalize m-0 d-flex justify-content-space-bet align-items-center pt-2 pb-2"
      >
        <p
          v-if="
            permissions.includes('CAN_EDIT_ADMIN_BLOGS') &&
            (this.$store.state.user.userDetails.is_super == true ||
              blogDetails.admin_user_id ==
                this.$store.state.user.userDetails._id)
          "
          @click="getEditDetails()"
          class="mb-0"
        >
          <image-view
            :src="'/img/avatars/edit-blog.png'"
            class="mr-2 editblogImage font-weight-bold"
          ></image-view>
          <span class="edit-text">EDIT BLOG</span>
        </p>

        <v-btn
          v-if="blogDetails.status !== 'DRAFT'"
          @click="getViewDetails()"
          text
          x-large
          color="success"
        >READ MORE</v-btn>
      </div>
      <!-- <router-link
        v-if="blogDetails.status !== 'DRAFT'"
        :to="'/blog/' + blogDetails.slug"
        tag="h5"
        class="text-capitalize m-0 d-flex justify-content-space-bet align-items-center pt-2 pb-2"
      >
        <p class="mb-0">
          <image-view :src="'/img/avatars/edit-blog.png'" class="mr-2 editblogImage"></image-view>Edit Blog
        </p>
        <p class="cursor mb-0 mt-2 flex-end text-success">READ MORE</p>
      </router-link>
      <router-link
        v-else
        :to="{ name: 'Create Blog', params: { id: blogDetails._id } }"
        tag="h5"
        class="text-capitalize m-0 d-flex justify-content-space-bet align-items-center pt-2 pb-2"
      >
        <p class="mb-0">
          <image-view :src="'/img/avatars/edit-blog.png'" class="mr-2 editblogImage"></image-view>Edit Blog
        </p>
        <p class="cursor mb-0 mt-2 flex-end text-success">READ MORE</p>
      </router-link>-->
    </CCardBody>
    <CCardFooter class="flex-end">
      <!-- DELETE BUTTON -->
      <span v-if="!!blogDetails.is_published && blogDetails.status === 'APPROVED'">
        <v-btn
          v-if="
            permissions.includes('CAN_DELETE_ADMIN_BLOGS') &&
            (this.$store.state.user.userDetails.is_super == true ||
              blogDetails.admin_user_id ==
                this.$store.state.user.userDetails._id)
          "
          color="error"
          class="ml-2 mr-2"
          disabled
          @click="openSwal('delete')"
        >Delete</v-btn>
      </span>
      <span
        v-else-if="
          !blogDetails.is_published && blogDetails.status === 'APPROVED'
        "
      >
        <v-btn
          v-if="
            permissions.includes('CAN_DELETE_ADMIN_BLOGS') &&
            (this.$store.state.user.userDetails.is_super == true ||
              blogDetails.admin_user_id ==
                this.$store.state.user.userDetails._id)
          "
          color="error"
          class="ml-2 mr-2"
          @click="openSwal('delete')"
        >Delete</v-btn>
      </span>

      <!-- DISCARD BUTTON -->
      <span v-else>
        <v-btn
          v-if="
            permissions.includes('CAN_DISCARD_ADMIN_BLOGS') &&
            (this.$store.state.user.userDetails.is_super == true ||
              blogDetails.admin_user_id ==
                this.$store.state.user.userDetails._id)
          "
          color="error"
          class="ml-2 mr-2"
          @click="openSwal('discard')"
        >Discard</v-btn>
      </span>

      <!-- UNPUBLISH BUTTON -->
      <span v-if="!!blogDetails.is_published && blogDetails.status === 'APPROVED'">
        <v-btn
          v-if="
            permissions.includes('CAN_UNPUBLISH_ADMIN_BLOGS') &&
            (this.$store.state.user.userDetails.is_super == true ||
              blogDetails.admin_user_id ==
                this.$store.state.user.userDetails._id)
          "
          color="success"
          class="ml-2 mr-2"
          @click="openSwal('unpublish')"
        >Unpublish</v-btn>
      </span>

      <!-- PUBLISH BUTTON -->
      <span v-else>
        <v-btn
          v-if="
            permissions.includes('CAN_PUBLISH_ADMIN_BLOGS') &&
            (this.$store.state.user.userDetails.is_super == true ||
              blogDetails.admin_user_id ==
                this.$store.state.user.userDetails._id)
          "
          color="success"
          class="ml-2 mr-2"
          @click="openSwal('publish')"
        >Publish</v-btn>
      </span>
      <!-- <v-btn color="success" >Unpublish</v-btn> -->
    </CCardFooter>
  </CCard>
</template>
<script>
import Swal from "sweetalert2";
import config from "@/config.js";
import { mapGetters } from "vuex";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
const Image = () => import("@/components/image.vue");
export default {
  props: ["blogDetails"],
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  components: {
    "image-view": Image
  },
  data() {
    return {
      dayJS,
      commentDetails: [],
      commentNumber: ""
    };
  },
  mounted() {
    this.getComments();
  },
  methods: {
    getEditDetails() {
      this.$router.push({
        name: "Create Blog",
        params: { id: this.blogDetails._id }
      });
    },

    getViewDetails() {
      this.$router.push(`/blog/${this.blogDetails.slug}`);
    },

    getDate(date) {
      return dayJS(date).format("Do MMMM YYYY");
    },
    getComments() {
      let url = `${config.BASE_URL}api/v2/admin/blog/comment/${this.blogDetails._id}`;
      let params = {
        page: this.currentPage,
        records_per_page: 3
      };
      this.$http.get(url, { params }).then(response => {
        if (response.body.status) {
          this.commentNumber = response.body.data.count;
          if (response.body.data.list) {
            this.commentDetails = response.body.data.list;
          } else {
            this.commentDetails = {};
          }
        }
      });
    },
    openSwal(status) {
      if (status === "delete") {
        Swal.fire({
          title: "Are you sure you want to Delete this blog",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          if (result.isConfirmed) {
            this.deleteBlog(status);
          }
        });
      } else if (status === "discard") {
        Swal.fire({
          title: "Are you sure you want to Discard this blog",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          if (result.isConfirmed) {
            this.deleteBlog(status);
          }
        });
      } else if (status === "publish") {
        Swal.fire({
          title: "Are you sure you want to Publish this blog",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          if (result.isConfirmed) {
            this.updateBlog(status);
          }
        });
      } else {
        Swal.fire({
          title: "Are you sure you want to Unpublish this blog",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          if (result.isConfirmed) {
            this.updateBlog(status);
          }
        });
      }
    },
    updateBlog(status) {
      let obj;
      if (status === "publish" || status === "unpublish") {
        obj = {
          title: this.blogDetails.title,
          cover_photo: this.blogDetails.cover_photo,
          short_description: this.blogDetails.short_description,
          description: this.blogDetails.description,
          tags: this.blogDetails.tags,
          status: status
        };
      } else {
        obj = {
          is_deleted: true
        };
      }
      let url = `${config.BASE_URL}api/v2/admin/blogs/${this.blogDetails._id}`;
      this.$http.post(url, obj).then(response => {
        if (!!response.ok) {
          if (status === "publish") {
            Swal.fire({
              title: "Blog Published Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("refreshList");
              }
            });
          } else if (status === "unpublish") {
            Swal.fire({
              title: "Blog Unpublished Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("refreshList");
              }
            });
          } else {
            Swal.fire({
              title: "Blog Saved Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("refreshList");
              }
            });
          }
        }
      });
    },
    deleteBlog(status) {
      let url = `${config.BASE_URL}api/v2/admin/blogs/${this.blogDetails._id}`;
      this.$http.delete(url, {}).then(response => {
        if (!!response.ok) {
          Swal.fire({
            title:
              status === "delete"
                ? "Blog Deleted Successfully"
                : "Blog Discarded Successfully",
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "Ok"
          }).then(result => {
            if (result.isConfirmed) {
              this.$emit("refreshList");
            }
          });
        }
      });
    }
  }
};
</script>